import rawMotions from './danceMotions.json';

export type DanceMotionConfig = {
  id: string;
  label: string;
};

const normalizeDanceMotions = (value: DanceMotionConfig[]) =>
  value
    .filter((item) => item && typeof item.id === 'string' && typeof item.label === 'string')
    .map((item) => ({ id: item.id, label: item.label }));

export const DANCE_MOTIONS: DanceMotionConfig[] = normalizeDanceMotions(rawMotions as DanceMotionConfig[]);

export const DEFAULT_DANCE_MOTION_ID = DANCE_MOTIONS[0]?.id ?? '';

export const getDanceLabel = (id?: string) =>
  DANCE_MOTIONS.find((motion) => motion.id === id)?.label;
